import React from 'react'

import SectionHeader from 'components/SectionContent'
import SortableChart from 'screens/web/farm-data-analysis/sortable-analysis-charts'
import noop from 'modules/noop'
import registerToDataSource from './registerToDataSource'
import historicalDataByRegister from './historicalDataByRegister'

const xOffset = 216
const xStart = '2017-06-06T01:22:45.041Z'
const xEnd = '2017-06-13T01:22:45.041Z'
const selectedRegisters = ['2014', '2016', '12']

class AnalysisChart extends React.Component {
  renderSensorName (sensor) {
    const name = sensor.name.toLowerCase()
    const words = name.split(' ')
    return <span><b>{words[0]}</b> {words.slice(1).join(' ')}</span>
  }

  render () {
    return (
      <div className="container demo-charts">
        <SectionHeader
          headerColor="text-teal"
          headerContent="No More Guess Work"
          subheaderColor="text-gray"
          subheaderContent="Farmhand’s analysis tool helps you compare the impact your equipment is having on your climate so you can pinpoint any fluctuations."
        />
        <div className="box-with-shadow">
          <SortableChart
            selectedRegisters={selectedRegisters}
            xStart={xStart}
            xEnd={xEnd}
            xOffset={xOffset}
            onRequestReorder={noop}
            onRequestRemoveIndex={noop}
            renderName={this.renderSensorName}
            registerToDataSource={registerToDataSource}
            historicalDataByRegister={historicalDataByRegister}
          />
        </div>
        <h6 className="chartCaption">Preview of Farmhand analysis tool</h6>
        <div className="container">
          <div className="chart-points columns">
            <div className="column">
              <p className="text-teal">Drag and drop different variables to compare</p>
            </div>
            <div className="column">
              <p className="text-teal">Select a date range to view historical data</p>
            </div>
            <div className="column">
              <p className="text-teal">Analyze the impact equipment is having on climate</p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AnalysisChart



// WEBPACK FOOTER //
// ./containers/Analyze/index.js